const styles = {
  menuPortal: base => ({ ...base, zIndex: 9999 }),
  container: provided => ({
    ...provided,
    fontFamily: "'EYInterstate', sans-serif",
    fontSize: '14px',
    color: '#333',
    width: '100%',
    outline: 'none',
  }),
  control: (provided, state) => ({
    ...provided,
    width: '100%',
    backgroundColor: '#F6F6FA',
    borderRadius: 0,
    minHeight: '34px',
    border: 'none',
    boxShadow: null,
  }),
  placeholder: (provided, state) => {
    return {
      ...provided,
      fontSize: '14px',
      fontFamily: 'EYInterstate',
      color: '#747480',
    };
  },
  option: (provided, state) => {
    let backgroundColor;
    if (state.isFocused) {
      backgroundColor = '#F6F6FA';
    } else {
      backgroundColor = '#fff';
    }

    return {
      ...provided,
      backgroundColor: backgroundColor,
      color: state.isFocused ? '#333' : '#666666',
      padding: '8px 10px',
      '&:active': {
        backgroundColor: '#F6F6FA',
      },
    };
  },
  multiValueLabel: base => ({
    ...base,
    backgroundColor: '#F6F5FA',
    padding: '2px 10px',
    color: '#333',
  }),
  multiValueRemove: base => ({
    ...base,
    backgroundColor: '#F6F5FA',
    '&:hover': {
      backgroundColor: '#F6F5FA',
    },

    '.del-icon': {
      fontSize: '16px',
      marginLeft: '3px',
      cursor: 'pointer',
      verticalAlign: 'middle',
      color: '#747480',
      paddingBottom: '1px',
    },
  }),
};

export default styles;
